import { Component, OnInit, OnDestroy, ViewChild, Output, EventEmitter, Input, ElementRef } from '@angular/core';
import {NgbModal, NgbModalOptions, NgbDate, NgbDateStruct} from '@ng-bootstrap/ng-bootstrap';
import { ConfirmModalComponent } from 'ccc-commons/core';
import { License } from 'src/app/core/models/license.model';
import { LicensesService } from 'src/app/core/services/licenses.service';

@Component({
  selector: 'ccc-cca-licenses-modal',
  templateUrl: './licenses-modal.component.html',
  styleUrls: ['./licenses-modal.component.scss']
})
export class LicenseModalComponent implements OnInit, OnDestroy {
  @ViewChild('content')
  content: NgbModal;
  modal: any;
  errors = [];

  @Output()
  updateLicenses = new EventEmitter<any>();

  @ViewChild('modalSave')
  modalSave: ConfirmModalComponent;

  @ViewChild('selectType')
  selectTypeRef!: ElementRef<HTMLSelectElement>;

  @Input()
  licensesType;

  @Input()
  programProdCodes;

  @Input()
  organizationId;

  rolesToShow = [];

  schools = [];
  schoolsToShow = [];

  currentOrganizationId = '';
  index: number;

  modalOpts: NgbModalOptions = {
    size: 'lg',
    windowClass: 'animated faster zoomIn modal-custom ccc-new-modal',
    backdrop: 'static',
    beforeDismiss: () => {
      if (this.hasUnsavedChanges()) {
        this.modalSave.onOpen();
        return false;
      }
      this.clear();
      return true;
    }
  };

  isSending = false;
  selectedAffiliation = [];
  isAffiliationDeleted = false;
  generalErrors = [];
  knownErrorFields = ['email'];
  loadingRoles = [];

  editingElement: License = new License('', '', '', '', '', '', 0, '');


  licenseBeforeChanges = {
    docType: '',
    licenseKey: '',
    orderRef: '',
    startDate: '',
    endDate: '',
    externalProductId: '',
    purchasedSeats: 0,
    notes: '',
    id: ''
  };
  isEditing = false;
  isLoading = false;
  startDate;
  endDate;
  previousPath = '';

  constructor(
    private modalService: NgbModal,
    private licenseService: LicensesService,

  ) { }

  ngOnInit() {
  }

  open(isEdit = false) {
    this.isEditing = isEdit;

    this.modal = this.modalService.open(this.content, this.modalOpts);
    this.modal.result.then(
      () => {
        this.clear();
      },
      () => {
        this.clear();

      }
    );
    setTimeout(() => {
      this.selectTypeRef.nativeElement.focus();
    });
  }

  openToEdit(license) {
    this.isEditing = true;
    const licenseStartdDate = new Date(license.startDate);
    const licenseEndDate = new Date(license.endDate);

    this.startDate = new NgbDate(
      licenseStartdDate.getFullYear(),
      licenseStartdDate.getMonth() + 1,
      licenseStartdDate.getDate()
    );

    this.endDate = new NgbDate(
      licenseEndDate.getFullYear(),
      licenseEndDate.getMonth() + 1,
      licenseEndDate.getDate()
    );
    this.editingElement = license;

    this.licenseBeforeChanges = {
      docType: license.docType,
      licenseKey: license.licenseKey,
      orderRef: license.orderRef,
      startDate: license.startDate,
      endDate: license.endDate,
      externalProductId: license.externalProductId,
      purchasedSeats: license.purchasedSeats,
      notes: license.notes,
      id: license.id
    };

    this.open(true);

  }

  hasUnsavedChanges() {
    if (this.isEditing) {
      const startDate = new Date(
        this.startDate.year,
        this.startDate.month - 1,
        this.startDate.day
      );
      const endDate = new Date(
        this.endDate.year,
        this.endDate.month - 1,
        this.endDate.day
      );

      const dateChanges = endDate.getTime() !== new Date(this.licenseBeforeChanges.endDate).getTime() ||
        startDate.getTime() !== new Date(this.licenseBeforeChanges.startDate).getTime();


      return this.editingElement.docType !== this.licenseBeforeChanges.docType ||
        this.editingElement.orderRef !== this.licenseBeforeChanges.orderRef ||
        this.editingElement.externalProductId !== this.licenseBeforeChanges.externalProductId ||
        this.editingElement.licenseKey !== this.licenseBeforeChanges.licenseKey ||
        this.editingElement.notes !== this.licenseBeforeChanges.notes ||
        this.editingElement.purchasedSeats !== this.licenseBeforeChanges.purchasedSeats || dateChanges;

    } else {
      return this.editingElement.docType !== '' ||
        this.editingElement.externalProductId !== '' ||
        this.editingElement.licenseKey !== '' ||
        this.editingElement.notes !== '' ||
        this.editingElement.purchasedSeats !== 0;

    }

  }



  onClose() {
    this.clear();
    this.modal.close();
  }

  ngOnDestroy() {
    if (this.modal) {
      this.modal.close();
    }
  }

  onCloseWithoutSaving(close) {
    if (close) {
      this.clear();
      this.modal.close();
    }
  }


  onCloseWarning() {
    this.errors = [];
  }

  onDismiss() {
    this.modal.dismiss();
  }

  onSubmit() {
    this.isSending = true;

    const startDate = new Date(
      this.startDate.year,
      this.startDate.month - 1,
      this.startDate.day
    );
    const endDate = new Date(
      this.endDate.year,
      this.endDate.month - 1,
      this.endDate.day
    );

    this.editingElement.startDate = startDate.toISOString();
    this.editingElement.endDate = endDate.toISOString();

    if (!this.isEditing) {
      this.licenseService
        .createOrganizationLicense(this.editingElement, this.organizationId)
        .subscribe(
          resp => {
            this.updateLicenses.emit('License created successfully');
          },
          error => {
            this.isSending = false;
            this.handleErrors(error);

          }
        );
    } else {
      this.licenseService
        .updateOrganizationLicense(
          this.editingElement,
          this.organizationId,
          this.editingElement.id
        )
        .subscribe(
          resp => {
            this.updateLicenses.emit('License updated successfully');
          },
          error => {
            this.isSending = false;
            this.handleErrors(error);
          }
        );
    }
  }

  handleErrors(error) {
    this.errors = [];
    this.isSending = false;
    error = error.error;
    if (Array.isArray(error.message)) {
      for (const msg of error.message) {
        this.errors[msg.field] = [];
        for (const err of msg.errors) {
          this.errors[msg.field].push(err);
        }
      }
    } else {
      this.errors[error.field] = [];
      this.errors[error.field].push(error.message);
    }
    this.isSending = false;
  }


  canAdd() {

      return (
        this.startDate !== undefined &&
        this.endDate !== undefined &&
        this.editingElement !== undefined &&
        this.editingElement.orderRef !== '' &&
        this.editingElement.externalProductId !== '' &&
        this.editingElement.docType !== '' &&
        this.editingElement.purchasedSeats > 0 &&
        (!this.errors['orderRef'] || !this.errors['orderRef'].length) &&
        (!this.errors['licenseKey'] || !this.errors['licenseKey'].length));
  }

  clear() {
    this.isSending = false;
    this.errors = [];
    this.rolesToShow = [];
    this.schoolsToShow = [];
    this.selectedAffiliation = [];
    this.generalErrors = [];
    this.editingElement =
      new License('', '', '', '', '', '', 0, '');
    this.startDate = new Date();
    this.endDate = new Date();
  }

  /***
   * defines the earlier allowed end date in order to prevent expired dates and
   * end dates before start date
   */
  public getMinEndDate(): NgbDateStruct {
    const today = new Date();
    let endDate = today;
    if (this.startDate) {
      const dateStart = new Date(this.startDate.year, this.startDate.month - 1, this.startDate.day);
      // only if you are editing you can select a date in the past
      // end date always must be same or after start date
      endDate = this.isEditing || dateStart > today ? dateStart : today;
    }
    return new NgbDate(endDate.getFullYear(), endDate.getMonth()  + 1, endDate.getDate());
  }
}
